import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    createdByYou: string;
    createdByOther: (creatorName: string) => string | React.ReactNode;
    label: (name: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Subtitle shown when the current user created the share list */
            createdByYou: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareListAccessRow.createdByYou?c=20accoqfibq8n", defaultMessage: "by you" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Subtitle shown when another user created the share list */
            createdByOther: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (creatorName: string) => __intl__.intl().formatMessage({ id: "ShareListAccessRow.createdByOther?c=8rzadaxrxghx", defaultMessage: "by {creatorName}" }, { creatorName: creatorName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for a share list entry */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "ShareListAccessRow.label?c=2csub7xwxcjrm", defaultMessage: "Open share list {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
